// apiClient.js
import axios from "axios";
import storage from "./storageFactory";
const API_BASE_URL = "https://goldfinger.hooverandstrong.com/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 600000,
});

apiClient.interceptors.request.use((config) => {
  const token = storage.getStorageItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      storage.removeStorageItem("authToken");
      storage.removeStorageItem("user");

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
